import { reactive } from 'vue'

export const store = reactive({
  isNavigationShow: false
})